import { useLDClient } from 'launchdarkly-react-client-sdk'
import { useEffect, useState } from 'react'

/**
 * Returns true once LaunchDarkly has finished initialising and flag values are
 * trustworthy. `useFlags()` returns LD defaults (e.g. `false`) before the client
 * is ready, so any logic that branches on a flag — especially redirects — must
 * wait for this signal to avoid acting on a default and bouncing the user.
 *
 * In production LD bootstraps from localStorage, so this resolves near-instantly
 * for returning users; cold caches and local dev resolve once the client connects.
 */
export const useLdReady = (): boolean => {
  const ldClient = useLDClient()
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (!ldClient) return

    let cancelled = false
    void ldClient.waitUntilReady().then(() => {
      if (!cancelled) setIsReady(true)
    })

    return () => {
      cancelled = true
    }
  }, [ldClient])

  return isReady
}
